import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Grid,
} from '@material-ui/core'

import BloksOutlineImage from '../../../assets/images/hero_graphic_solution.svg'

import { withTracking } from '../Tracking'
import Footer from '../authentication/Footer'
import TopNav from './TopNav'

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    contentColumnContainer: {
      minHeight: '100vh',
      backgroundColor: '#FFD850',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      backgroundImage: `url(${BloksOutlineImage})`,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
      },
      flexWrap: 'nowrap',
    },
    promptContainer: {
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(2, 0),
      },
      [theme.breakpoints.up('md')]: {
        margin: theme.spacing(3, 0),
      },
      flexGrow: 1,
    },
  })

  render() {
    const { children, classes } = this.props

    return (
      <Grid container direction="column" justify="center" className={classes.contentColumnContainer}>
        <Grid item>
          <TopNav />
        </Grid>
        <Grid item container className={classes.promptContainer} direction="column" justify="center" alignItems="center">
          { children }
        </Grid>
        <Grid item>
          <Footer />
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(Layout.styles)(withTracking(Layout))
